const ArrowDownIcon = () => {
  return (
    <svg width='9' height='5' viewBox='0 0 9 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0.541992 0.416748L4.50033 4.37508L8.45866 0.416748H0.541992Z' fill='#444D4E' />
    </svg>
  )
}

export default ArrowDownIcon
